import o from"react";const e={google:o.lazy((()=>import("./Google.js"))),yandex:o.lazy((()=>import("./Yandex/index.js")))},r=o=>e[o];export{r as getMapComponent};
//# sourceMappingURL=index.js.map
